import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, UNAUTHORIZED, selectMeStatus } from './selectors';
import { setCurrentNetworkId } from './currentNetwork';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { Thunk } from '../types';

export const loadMe = (): Thunk => async (dispatch, getState, { request }) => {
  const key = 'me';
  /* istanbul ignore next */
  if (selectMeStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [key]: LOADING }, 'me/LOAD_REQUEST'));

  try {
    const data = await request.get(`${PODCASTERS_SERVICE}/v0/user/me`).then(toJSON);
    const networkAuthorizations = Object.keys(data.authorizations).filter(a =>
      /licensor:[0-9a-z]+/i.test(a),
    )[0];

    // only set a network if the user is affliated to a network
    if (networkAuthorizations) {
      const networkId = networkAuthorizations.replace('spotify:licensor:', '');
      dispatch(setCurrentNetworkId(networkId));
    }

    const showAuthorizations = Object.keys(data.authorizations).filter(a =>
      /show:[0-9a-z]+/i.test(a),
    )[0];

    const permissions = {
      godMode: data.employee,
      network: data.employee || !!networkAuthorizations,
      podcast: !!showAuthorizations,
    };

    dispatch(
      batchActions(
        [
          setData({
            [key]: {
              ...data,
              permissions,
            },
          }),
          unsetStatus([key]),
        ],
        'me/LOAD_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        if (err.message === '401') {
          dispatch(setStatus({ [key]: UNAUTHORIZED }, 'me/LOAD_UNAUTHORIZED'));
        } else {
          dispatch(setStatus({ [key]: ERROR }, 'me/LOAD_ERROR'));
        }

        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};
